module.exports = __webpack_public_path__ + "img/1-1.05f0144c.webp";